import React from 'react';
import { useDispatch } from 'react-redux';
import { useTrialUpgradeRequestMutation as useSharedTrialUpgradeRequestMutation } from '@discover-frontend/components';

import { addToast } from 'src/actions/ToastActions';

export const usePostTrialUpgradeRequest = (onSuccessClose: () => void) => {
  const dispatch = useDispatch();

  return useSharedTrialUpgradeRequestMutation(onSuccessClose, {
    onNotifySuccess: (message) =>
      dispatch(addToast({ status: 'success', message })),
    onNotifyError: (message) =>
      dispatch(addToast({ status: 'error', message })),
  });
};
